const closeButtonLabel = "Fechar";
const ptBR = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  ptBR as default
};
